/**
 * @file TabNotes.jsx
 * @description TabNotes component for displaying and managing tab notes.
 * @component TabNotes
 * @exports TabNotes - Main component for displaying and managing tab notes.
 */

import React, { useState, useEffect } from "react";
import {
  Box,
  //Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { getcustomernotes, addcustomernotes } from "../../../services/customerinfoModule/notesServices";
import ProgressOverlay from "../../../common/components/ProgressOverlay";
import { useRegisterCsvExport } from "../../customerModule/customers/CsvExportContext.jsx";
import { NOTES_COLUMNS } from "../../customerModule/customers/customerExportConfig.js";

const CustomerNotes = ({ customerguid }) => {
  // Hardcoded GUIDs for testing
  const agentguid = localStorage.getItem("userguid");
  /* const acsIdentity = localStorage.getItem("acsIdentity");
  const workerid = localStorage.getItem("workerid");
  const userguid = localStorage.getItem("userguid"); */

  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [loading, setLoading] = useState(false);

  useRegisterCsvExport({
    name: "notes",
    columns: NOTES_COLUMNS,
    rows: notes,
    enabled: !loading,
  });

  useEffect(() => {
    if (customerguid) fetchNotes();
  }, [customerguid]);

  const fetchNotes = async () => {
    setLoading(true);
    try {
      const data = await getcustomernotes({ customerguid });
      setNotes(data || []);
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddNote = async () => {
    if (!newNote.trim()) return;

    try {
      await addcustomernotes({
        customerguid,
        notesvalue: newNote,
        agentguid,
      });
      setNewNote("");
      fetchNotes(); // Refresh notes
    } catch (error) {
      console.error("Error adding note:", error);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString();
  };

  return (
    <Box sx={{ p: 2 }}>
      {loading && <ProgressOverlay />}
      {/* <Typography variant="h6" gutterBottom>
        Customer Notes
      </Typography> */}

      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <TextField
          fullWidth
          label="Add a note"
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
        />
        <Button variant="contained" color="primary" onClick={handleAddNote}>
          Add
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 500,
          overflowY: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>Note</b>
              </TableCell>
              <TableCell>
                <b>Created At</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notes.length === 0 && !loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No notes found
                </TableCell>
              </TableRow>
            ) : (
              notes.map((note, index) => (
                <TableRow key={index}>
                  <TableCell>{note.notesvalue}</TableCell>
                  <TableCell>{formatDate(note.createdAt)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CustomerNotes;